import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { LoadingSvg } from "../../../../../utils/SvgIcons";
import {
  answerTicketApi,
  getOneTicketDetailsApi,
} from "../../../../../../../services/supportApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../../../utils/utilsFunctions";

const BoxStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.black,
  // theme.palette.action.hover,
  padding: "0px 20px",
  border: "solid",
  borderRadius: "25px",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    display: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data) {
  return { name, data };
}

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededData = {
  ticketContent: "متن",
  file: "فایل پیوست",
  createdAt: "تاریخ",
};

export default function OneTicketDetails(props) {
  const { ticketId } = props;

  // اگر سایز صفحه از 600 پیکسل کوچکتر شود مقدار ترو برمیگرداند
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [fetchedOneTicketDetails, setFetchedOneTicketDetails] = useState({
    docs: [],
    loading: "llmmt-loading",
  });
  const [replyText, setReplyText] = useState("");
  const [errorText, setErrorText] = useState(false);
  const [pageAndPerPage, setPageAndPerPage] = useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });

  const RecivedData = fetchedOneTicketDetails["docs"];

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getOneTicketDetailsFromBack(
      "getOneTicketDetails",
      { ticketId },
      PageAndPerPageValue
    );
  };

  const getOneTicketDetailsFromBack = async (
    request,
    data,
    paginateData = {}
  ) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setFetchedOneTicketDetails({ docs: [], loading: "llmmt-loading" });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "getOneTicketDetails") {
        let response = await getOneTicketDetailsApi({ ticketId }, paginate);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
          setFetchedOneTicketDetails(resData["data"]);
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            resData["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
          setFetchedOneTicketDetails({
            docs: [],
            loading: "llmmt-Error-loading",
          });
        }
      }
    } catch (error) {
      setFetchedOneTicketDetails({ docs: [], loading: "llmmt-Error-loading" });
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const answerTicket = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      if (replyText.length == 0) {
        setErrorText(true);
        toast.update(toastMsg, { render: "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        return false;
      } else {
        const response = await answerTicketApi({ ticketId, ticketContent: replyText });
        const resData = checkResponseData(response);
        if (resData["success"] && resData["message"])
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        else {
          toast.update(toastMsg, { render: "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };
  useEffect(() => {
    getOneTicketDetailsFromBack("getOneTicketDetails", {});
  }, []);

  // let allStatusCodeState = {};
  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable = RecivedData.map((el, index) => {
    const rowOfTableData = [];
    rowOfTableData[0] = el;
    for (const property in el) {
      // دیتاهایی که در neededData گفته ایم نیاز داریم را جدا می کند
      if (neededData[property]) {
        // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
        if (property == "createdAt") {
          const date = new DateObject({
            date: el[property],
            calendar: persian,
            locale: persian_fa,
          });
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: date.format(),
            })
          );
        } else
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property],
            })
          );
      }
    }
    return rowOfTableData;
  });

  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم
  const showRowData = (index, data, oneRow) => {
    const { name, data: content } = data;
    if (name == "status") {
      switch (content) {
        case "answerByUser":
          return <StyledTableCell align="left">پاسخ کاربر</StyledTableCell>;
        case "closeTicket":
          return <StyledTableCell align="left">بسته شده</StyledTableCell>;
        case "openTicket":
          return <StyledTableCell align="left">تیکت باز </StyledTableCell>;
        case "answerBySupoort":
          return (
            <StyledTableCell align="left">پاسخ پشتبانی سایت </StyledTableCell>
          );
        default:
          return <StyledTableCell align="left">نامشخص</StyledTableCell>;
      }
    } else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  return (
    <>
      <Box>
        {
          fetchedOneTicketDetails.loading &&
            fetchedOneTicketDetails.loading == "llmmt-loading" ? (
            <Box
              sx={{
                backgroundColor: "#001e6a",
                m: 1,
                px: 1,
                py: 5,
                color: "white",
                borderRadius: 5,
                textAlign: "center",
              }}
            >
              <LoadingSvg />
              <Divider>لطفا تا بارگزاری اطلاعات صبر کنید </Divider>
            </Box>
          ) : fetchedOneTicketDetails.loading &&
            fetchedOneTicketDetails.loading == "llmmt-Error-loading" ? (
            "ارور لودینگ"
          ) : (
            // (
            <>
              <BoxStyled>
                <Divider></Divider>
                <Chip sx={{ my: 1 }} label="ارسال پاسخ جدید:" />
                <TextField
                  id="outlined-multiline-static"
                  sx={{ mb: 1, px: 1 }}
                  label="پاسخ"
                  fullWidth
                  multiline
                  rows={4}
                  onChange={(e) => {
                    setReplyText(e.target.value);
                  }}
                />
                <Typography
                  sx={{
                    color: "white",
                    backgroundColor: "red",
                    textAlign: "center",
                  }}
                >
                  {replyText.length == 0 && errorText
                    ? "لطفا پیام را وارد کنید"
                    : ""}
                </Typography>
                <Button
                  sx={{ m: 5 }}
                  variant="contained"
                  onClick={answerTicket}
                >
                  ارسال پاسخ
                </Button>
              </BoxStyled>
              {listOfTable.map((oneRow, index) => (
                <TableContainer
                  key={`MainTable-${index}`}
                  component={Paper}
                  sx={{
                    mb: 1,
                    backgroundColor: index % 2 == 0 ? "" : "dimgrey",
                    ml: index % 2 == 0 ? 0 : 1,
                    mr: index % 2 !== 0 ? 0 : 1,
                    border: index % 2 !== 0 ? "outset" : "ridge",
                    borderColor: index % 2 !== 0 ? "dimgrey" : "",
                    borderRadius:
                      index % 2 !== 0
                        ? "20px 0px 20px 0px"
                        : "0px 20px 0px 20px",
                  }}
                >
                  {index % 2 == 0 ? (
                    <Divider textAlign="left">
                      <Typography>{` (${listOfTable.length - index
                        }) `}</Typography>
                      <SpeakerNotesIcon color="warning" />
                    </Divider>
                  ) : (
                    <Divider textAlign="right">
                      <Typography>{` (${listOfTable.length - index
                        }) `}</Typography>
                      <SpeakerNotesIcon color="info" />
                    </Divider>
                  )}
                  <Table
                    key={`tbl-${index}`}
                    sx={{
                      minWidth: 10,
                    }}
                    aria-label="customized table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell
                          sx={{ width: detectSize600px ? "25%" : "50%" }}
                        ></StyledTableCell>
                        <StyledTableCell
                          sx={{ width: detectSize600px ? "75%" : "50%" }}
                          align="left"
                        ></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {oneRow.map((row, indexrow) =>
                        indexrow == 0 ? (
                          ""
                        ) : (
                          <StyledTableRow key={`-${indexrow}-${row.name}`}>
                            <StyledTableCell component="th" scope="row">
                              {row.name}
                            </StyledTableCell>
                            {showRowData(index, row.data, oneRow)}
                          </StyledTableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ))}
            </>
          )
          // )
        }
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            backgroundColor: "#7d8fdd",
          }}
        >
          <Pagination
            count={pageAndPerPage.totalPages}
            siblingCount={0}
            color="primary"
            hideNextButton={pageAndPerPage.hasNextPage}
            hidePrevButton={pageAndPerPage.hasPrevPage}
            // totalPages:0,
            // hasNextPage:false,
            // hasPrevPage:false,
            page={pageAndPerPage.page}
            // totalDocs:0,
            // totalPages: 0

            onChange={(e, value) => {
              setNumberPageAndPerPage("page", value);
            }}
          />
          {pageAndPerPage.totalPages == 0 ? null : (
            <>
              تعداد کل:{pageAndPerPage.totalDocs}
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">تعداد در هر صفحه</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  defaultValue={5}
                  value={pageAndPerPage.perPage}
                  label="تعداد در هر صفحه"
                  onChange={(e) => {
                    setNumberPageAndPerPage("perPage", e.target.value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={35}>35</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}
